import { render, staticRenderFns } from "./ScreeningPlanEdit.vue?vue&type=template&id=6b843fd6&scoped=true&"
import script from "./ScreeningPlanEdit.vue?vue&type=script&lang=js&"
export * from "./ScreeningPlanEdit.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningPlanEdit.vue?vue&type=style&index=0&id=6b843fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b843fd6",
  null
  
)

export default component.exports